import "./style.css";
import "./nav";
import "./sidebar";
import "./purchase-form";
import "./faq";
import "./accordion-zee";
import "./uploader";
import "./grid-hover-item/";
import "./may";
import "./slider-baker";
import "./yandex-map";
import "./slider-zee";
import "./service-filter";
